export const UPLOAD_JOB_REQUEST_FIREBASE_URL_COMPLETED = 'UPLOAD_JOB_REQUEST_FIREBASE_URL_COMPLETED';
export const UPLOAD_JOB_REQUEST_FIREBASE_URL_STARTED = 'UPLOAD_JOB_REQUEST_FIREBASE_URL_STARTED';
export const UPLOAD_JOB_REQUEST_FIREBASE_URL_FAILED = 'UPLOAD_JOB_REQUEST_FIREBASE_URL_FAILED';

export const FETCHING_ID_MARKET_STALL_STARTED = 'FETCHING_ID_MARKET_STALL_STARTED';
export const FETCHING_ID_MARKET_STALL_COMPLETED = 'FETCHING_ID_MARKET_STALL_COMPLETED';
export const FETCHING_ID_MARKET_STALL_FAILED = 'FETCHING_ID_MARKET_STALL_FAILED';